export const STATE_ABBREVIATIONS: Record<string, string> = {
  Alabama: 'AL',
  Arizona: 'AZ',
  Arkansas: 'AR',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District of Columbia': 'DC',
  Georgia: 'GA',
  Idaho: 'ID',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Montana: 'MT',
  Nebraska: 'NE',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
};

export const STATE_FORM_NAMES = [
  '1099-A',
  '1099-B',
  '1099-C',
  '1099-DA',
  '1099-DIV',
  '1099-G',
  '1099-INT',
  '1099-K',
  '1099-MISC',
  '1099-NEC',
  '1099-OID',
  '1099-PATR',
  '1099-Q',
  '1099-QA',
  '1099-R',
  '1099-S',
  '1099-SA',
  '592B',
  'FORM5498',
  'W-2C',
  'W-2G',
];

export const stateOptions = Object.entries(STATE_ABBREVIATIONS).map(
  ([name, value]) => ({ name, value }),
);

export const stateFormOptions = STATE_FORM_NAMES.map((f) => ({
  name: f,
  value: f,
}));
